var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-tab-pane",
    { attrs: { name: "security" } },
    [
      _c("div", { staticClass: "row gutter-x-xl" }, [
        _c("div", { staticClass: "col-12 col-md-3" }, [
          _c("h6", { staticClass: "q-mt-md q-mb-sm q-title" }, [
            _vm._v(_vm._s(_vm.$t("change_password")))
          ]),
          _c("p", { staticClass: "text-faded q-ma-none" }, [
            _vm._v(_vm._s(_vm.$t("change_password_hint")))
          ])
        ]),
        _c("div", { staticClass: "col-12 col-md-9" }, [
          _c(
            "form",
            {
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.handleSaveChanges($event)
                }
              }
            },
            [
              _c(
                "q-field",
                {
                  attrs: {
                    error: _vm.errors.has("password"),
                    "error-label": _vm.errors.first("password")
                  }
                },
                [
                  _c("q-input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate.disable",
                        value: "required|min:8",
                        expression: "'required|min:8'",
                        modifiers: { disable: true }
                      }
                    ],
                    attrs: {
                      type: "password",
                      name: "password",
                      "float-label": _vm.$t("password")
                    },
                    model: {
                      value: _vm.password,
                      callback: function($$v) {
                        _vm.password = $$v
                      },
                      expression: "password"
                    }
                  })
                ],
                1
              ),
              _c(
                "q-field",
                {
                  attrs: {
                    error: _vm.errors.has("password_confirmation"),
                    "error-label": _vm.errors.first("password_confirmation")
                  }
                },
                [
                  _c("q-input", {
                    attrs: {
                      type: "password",
                      name: "passwordConfirmation",
                      "float-label": _vm.$t("password_confirmation")
                    },
                    model: {
                      value: _vm.password_confirmation,
                      callback: function($$v) {
                        _vm.password_confirmation = $$v
                      },
                      expression: "password_confirmation"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "row justify-end" },
                [
                  _c("q-btn", { attrs: { type: "submit", color: "primary" } }, [
                    _vm._v(_vm._s(_vm.$t("save")))
                  ])
                ],
                1
              )
            ],
            1
          )
        ])
      ]),
      _c("hr"),
      _c(
        "div",
        { staticClass: "q-mt-md" },
        [
          _c("h6", { staticClass: "q-mb-sm q-title" }, [
            _vm._v(_vm._s(_vm.$t("tfa")))
          ]),
          _c("p", {
            staticClass: "text-faded",
            domProps: { innerHTML: _vm._s(_vm.$t("otp_hint")) }
          }),
          _c("p", { staticClass: "text-faded" }, [
            _c("span", { staticClass: "text-bold" }, [
              _vm._v(_vm._s(_vm.$t("status")) + ":")
            ]),
            _vm._v(" "),
            _c("span", { class: _vm.tfaTextClass }, [
              _vm._v(_vm._s(_vm.tfaStatusText))
            ])
          ]),
          _vm.user.two_factor_enabled
            ? _c(
                "q-btn",
                {
                  attrs: { color: "white", "text-color": "black" },
                  on: { click: _vm.handleDisable2FA }
                },
                [_vm._v("\n      " + _vm._s(_vm.$t("disable")) + "\n    ")]
              )
            : _vm._e(),
          !_vm.user.two_factor_enabled
            ? _c(
                "q-btn",
                {
                  attrs: { color: "white", "text-color": "black" },
                  on: { click: _vm.handleEnable2FA }
                },
                [_vm._v("\n      " + _vm._s(_vm.$t("enable")) + "\n    ")]
              )
            : _vm._e(),
          _vm.user.two_factor_enabled
            ? _c(
                "q-btn",
                {
                  staticClass: "on-right",
                  attrs: { color: "primary", flat: "" },
                  on: { click: _vm.handleBackupCodes }
                },
                [_vm._v("\n      " + _vm._s(_vm.$t("backup_codes")) + "\n    ")]
              )
            : _vm._e()
        ],
        1
      ),
      _c("tfa-modal", { ref: "tfaModal" }),
      _c("backup-codes-modal", { ref: "backupCodesModal" }),
      _c("authorization-dialog", { ref: "authorizationDialog" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }